import { useEffect } from "react";
import { ArrowLeft, FileText } from "lucide-react";

const Block = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl sm:text-2xl font-black text-[#0A1E3F] dark:text-white mb-3">{title}</h2>
    <div className="text-slate-600 dark:text-slate-300 text-sm sm:text-base leading-relaxed space-y-3">{children}</div>
  </section>
);

const TerminosPage = () => {
  useEffect(() => {
    document.title = "Términos de Servicio · Club Viajemos";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-[#0A1E3F]" style={{ fontFamily: "'Inter', system-ui, sans-serif" }} data-testid="terminos-page">
      <div className="bg-[#0A1E3F] text-white py-2 text-center text-xs sm:text-sm font-bold tracking-wider">
        <FileText className="inline h-3.5 w-3.5 mr-1.5 mb-0.5" />
        TÉRMINOS DE SERVICIO · CLUB VIAJEMOS
      </div>

      <div className="max-w-3xl mx-auto px-5 py-10">
        <a href="/" data-testid="terminos-back" className="inline-flex items-center gap-2 text-[#45A0EE] hover:underline text-sm font-semibold mb-8">
          <ArrowLeft className="h-4 w-4" /> Volver al inicio
        </a>

        <h1 className="text-3xl sm:text-4xl font-black text-[#0A1E3F] dark:text-white mb-2">Términos de Servicio</h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm mb-10">Última actualización: junio de 2026</p>

        <Block title="1. Aceptación de los términos">
          <p>Al acceder y utilizar el sitio web <b>www.clubviajemos.com</b> y los servicios de Club Viajemos ("la empresa", "nosotros"), aceptas quedar sujeto a estos Términos de Servicio. Si no estás de acuerdo con ellos, te pedimos no utilizar el sitio ni nuestros servicios.</p>
        </Block>

        <Block title="2. Descripción del servicio">
          <p>Club Viajemos ofrece una plataforma de formación, herramientas y recursos para agentes de viajes, así como productos y servicios turísticos. El contenido, precios y beneficios pueden actualizarse en cualquier momento.</p>
        </Block>

        <Block title="3. Uso permitido">
          <p>Te comprometes a utilizar el sitio y los servicios de forma lícita y a no:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Compartir tus credenciales de acceso con terceros no autorizados.</li>
            <li>Reproducir, distribuir o revender el contenido educativo sin autorización.</li>
            <li>Usar el sitio para fines fraudulentos o que perjudiquen a otros usuarios o a la empresa.</li>
          </ul>
        </Block>

        <Block title="4. Cuentas y accesos">
          <p>Algunos contenidos requieren un código o credenciales de acceso. Eres responsable de mantener la confidencialidad de dichos accesos y de toda actividad realizada bajo tu cuenta.</p>
        </Block>

        <Block title="5. Pagos y suscripciones">
          <p>Los pagos de planes, cursos o productos se procesan a través de proveedores externos (por ejemplo, Stripe, Hotmart u otros). Los precios están expresados en dólares estadounidenses (USD) salvo que se indique lo contrario. Las condiciones de reembolso, cuando apliquen, se indicarán en el momento de la compra.</p>
        </Block>

        <Block title="6. Comunicaciones y mensajes de texto (SMS)">
          <p>Al proporcionar tu número de teléfono y otorgar tu consentimiento, aceptas recibir comunicaciones por correo electrónico, llamadas y/o mensajes de texto (SMS) relacionadas con nuestros servicios. La frecuencia de los mensajes puede variar y pueden aplicar tarifas de mensajes y datos. Puedes cancelar en cualquier momento respondiendo <b>STOP</b>. El tratamiento de tus datos se rige por nuestra <a href="/privacidad" className="text-[#45A0EE] hover:underline">Política de Privacidad</a>.</p>
        </Block>

        <Block title="7. Propiedad intelectual">
          <p>Todo el contenido del sitio (textos, videos, cursos, logos, materiales y herramientas) es propiedad de Club Viajemos o de sus licenciantes y está protegido por las leyes de propiedad intelectual. Queda prohibida su reproducción no autorizada.</p>
        </Block>

        <Block title="8. Limitación de responsabilidad">
          <p>Los resultados económicos mencionados en el sitio son referenciales y no constituyen una garantía de ingresos. Los resultados dependen del esfuerzo, la constancia y el mercado de cada persona. Club Viajemos no será responsable por daños indirectos derivados del uso del sitio o los servicios.</p>
        </Block>

        <Block title="9. Modificaciones">
          <p>Podemos modificar estos Términos de Servicio en cualquier momento. Las actualizaciones se publicarán en esta página con su fecha correspondiente.</p>
        </Block>

        <Block title="10. Contacto">
          <p>Para consultas sobre estos Términos de Servicio, contáctanos:</p>
          <ul className="list-none space-y-1">
            <li><b>Correo:</b> info@clubviajemos.com</li>
            <li><b>Teléfono / WhatsApp:</b> +1 (954) 805-9212</li>
            <li><b>Sitio web:</b> www.clubviajemos.com</li>
          </ul>
        </Block>

        <a href="/privacidad" data-testid="terminos-to-privacidad" className="text-[#45A0EE] hover:underline text-sm font-semibold">Ver también nuestra Política de Privacidad →</a>
      </div>
    </div>
  );
};

export default TerminosPage;
